import { useSelector } from "react-redux";
import SearchTermOperationCard from "./SearchTermOperationComponents/SearchTermOperationCard";
import SearchTermOperationTabs from "./SearchTermOperationComponents/SearchTermOperationTabs/SearchTermOperationTabs";
// import ScopesSkeleton from "./SearchTermSkeletons/ScopesTabSkeleton";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import FloatingActionItems from "../../../../pages/FloatingItems/FloatingActionItems";
// import SearchTermTabskeleton from "./SearchTermSkeletons/SearchTermTabskeleton";
import { useSearchParams } from "react-router-dom";

const SearchTermOperation = () => {
  const {
    // isScopesLoading,
    isScopesTabDataFetched,
    selectedSTOperationSharedUid,
  } = useSelector((state: any) => state.searchTermOperation); //Get data from Scope Tab slice

  const { isSearchTermTabDataFetched } = useSelector(
    (state: any) => state.searchTermTab
  ); //Get data from SearchTermTab slice

  const { isAiRecDataFetched } = useSelector(
    (state: any) => state.aiRecomandationTab
  );

  const [searchParams] = useSearchParams();
  // const isAiRecTab = searchParams.get("tab") === "AI_RECOMMENDATIONS";
  const isClicked = searchParams.get("clicked");

  // Check if any tab has data fetched
  const isAnyTabDataFetched =
    isScopesTabDataFetched ||
    isSearchTermTabDataFetched ||
    isAiRecDataFetched ||
    // isAiRecTab ||
    isClicked;

  // Check if we're in initial loading state (no data fetched yet)
  // const isInitialLoading =
  //   isScopesLoading || searchTermTabLoader || loadingAiRecomendation;

  // // Determine which skeleton to show for initial loading
  // const initialSkeleton = isScopesLoading ? (
  //   <ScopesSkeleton />
  // ) : searchTermTabLoader ? (
  //   <SearchTermTabskeleton />
  // ) : (
  //   <SearchTermTabskeleton />
  // );

  return (
    <div>
      <SearchTermOperationCard />
      {isAnyTabDataFetched ? (
        <>
          <SearchTermOperationTabs />
          <div data-tracker="512">
            <FloatingActionItems
              selectedSiteFloatingAction={selectedSTOperationSharedUid}
              selectedDimensionsFloatingAction=""
              trackIdFloatingAction="513"
            />
          </div>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography
            variant="body2"
            sx={{ mt: 3, textAlign: "center", color: "#888" }}
          >
            No data available. Please select a website, then choose an account,
            and click "Get Data".
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default SearchTermOperation;
